import * as React from 'react';
import { ITronLogoUserVisual } from './dtp-resources.controller';

export interface IDtpResourcesInformationProps {
    data: ITronLogoUserVisual | null;
}

export const DtpResourcesInformation = (props: IDtpResourcesInformationProps) => {
    return (
        <div className="form-text-wrapper">
            <span className="form-text-label">User email:</span>{props.data && props.data.email} <br />
            <span className="form-text-label">Product Name:</span>{props.data && props.data.productName}<br />
            <span className="form-text-label">Product Code:</span>{props.data && props.data.productCode}<br />
            <span className="form-text-label">Created:</span>{props.data && props.data.created.toLocaleDateString()}<br />
            <span className="form-text-label">Status:</span>{props.data && props.data.isConfirmed ? "Approved" : ""}{props.data && props.data.isConfirmed === false ? "Preview" : ""}<br />
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/dtp-resources/dtp-resources-information.component.tsx